module.exports = __webpack_public_path__ + "img/cannery-3.0101473c.jpg";